export const getApiStatus = (error) =>
  error?.status ?? error?.response?.status;

export const EXAM_PASSWORD_DUPLICATED_CODE = "EXAM_PASSWORD_DUPLICATED";

export const EXAM_PASSWORD_DUPLICATED_MESSAGE =
  "この試験用パスワードは既に他の会社で使用されています。別のパスワードを入力してください。";

// 会社名重複と試験用パスワード重複はどちらも409なので、APIが返すコードで区別する。
export const isExamPasswordDuplicatedError = (error) =>
  getApiStatus(error) === 409 &&
  error?.response?.data?.code === EXAM_PASSWORD_DUPLICATED_CODE;

export const getManagementApiErrorMessage = (error) => {
  // APIのメッセージは英語なので、画面へ出す前に日本語へ差し替える。
  if (isExamPasswordDuplicatedError(error)) {
    return EXAM_PASSWORD_DUPLICATED_MESSAGE;
  }

  const responseMessage = error?.response?.data?.message;

  if (responseMessage) {
    return responseMessage;
  }

  switch (getApiStatus(error)) {
    case 400:
      return "入力内容を確認してください。";
    case 401:
      return "認証情報を確認できませんでした。再度ログインしてください。";
    case 403:
      return "この操作を行う権限がありません。";
    case 404:
      return "対象の情報が見つかりません。";
    case 409:
      return "ログインIDが他の管理者と重複しています。";
    case 0:
      return "APIに接続できませんでした。ネットワークまたはCORS設定を確認してください。";
    default:
      return "処理に失敗しました。時間を置いて再試行してください。";
  }
};
